var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRemedy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.62 1.98047H7.37996C6.31957 1.98047 5.45996 2.84008 5.45996 3.90047V4.93047C5.45996 5.99086 6.31957 6.85047 7.37996 6.85047H16.62C17.6803 6.85047 18.54 5.99086 18.54 4.93047V3.90047C18.54 2.84008 17.6803 1.98047 16.62 1.98047Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8899 6.85059H8.09985V9.27059H15.8899V6.85059Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.78 9.27051H7.21996C6.24794 9.27051 5.45996 10.0585 5.45996 11.0305V20.7605C5.45996 21.7325 6.24794 22.5205 7.21996 22.5205H16.78C17.752 22.5205 18.54 21.7325 18.54 20.7605V11.0305C18.54 10.0585 17.752 9.27051 16.78 9.27051Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45996 13.3506H10.77C11.47 13.3506 12.03 13.9106 12.03 14.6106V18.3506C12.03 19.0506 11.47 19.6106 10.77 19.6106H5.45996V13.3506Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9499 13.3506H18.5399V19.6106H16.9499C16.3699 19.6106 15.8899 19.1406 15.8899 18.5506V14.4106C15.8899 13.8306 16.3599 13.3506 16.9499 13.3506Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemedy);
export default __webpack_public_path__ + "static/media/iconRemedy.2e8c602fce00871a8e1a3250349a0bdd.svg";
export { ForwardRef as ReactComponent };